import React from 'react';
import styled from 'styled-components';
import { COLORS } from '../../../theme/Colors';

const SimpleFooter: React.FC = () => {
  return (
    <FooterContainer>
      <FooterContent>
        <FooterText>ILLUMINATE</FooterText>
        <ContactText>
          For any issues or questions please contact at{' '}
          <ContactLink href="mailto:contact@illuminateus.app">
            contact@illuminateus.app
          </ContactLink>
        </ContactText>
      </FooterContent>
    </FooterContainer>
  );
};

const FooterContainer = styled.footer`
  background-color: ${COLORS.white};
  padding: 40px 20px;
  text-align: center;
  margin-top: auto;
  border-top: 1px solid ${({ theme }) => theme.colors.inputBorder};
  overflow-x: hidden;
  width: 100%;
  box-sizing: border-box;
`;

const FooterContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
`;

const FooterText = styled.h2`
  color: transparent;
  font-weight: 700;
  margin: 0 0 16px 0;
  -webkit-text-stroke: 2px ${COLORS.darkPurple};
  font-family: Roboto, sans-serif;
  font-size: 4.5rem;
  text-transform: uppercase;
  line-height: 1.1;
  letter-spacing: 5px;
  text-rendering: optimizelegibility;
  display: inline-block;
  max-width: 100%;
  margin: 20px auto 35px;
  text-align: center;
  overflow-wrap: break-word;
  word-wrap: break-word;
  padding: 0 20px;
  box-sizing: border-box;
  
  @media (max-width: 768px) {
    font-size: 3rem;
    -webkit-text-stroke: 1.5px ${COLORS.darkPurple};
    letter-spacing: 3px;
  }
  
  @media (max-width: 480px) {
    font-size: 2rem;
    -webkit-text-stroke: 1px ${COLORS.darkPurple};
    letter-spacing: 2px;
    margin: 15px auto 25px;
  }
`;

const ContactText = styled.p`
  color: ${COLORS.textDark};
  font-size: 16px;
  margin: 0;
`;

const ContactLink = styled.a`
  color: ${COLORS.textDark};
  text-decoration: none;
  transition: color 0.2s ease;
  
  &:hover {
    color: ${COLORS.accent};
    text-decoration: underline;
  }
`;

export default SimpleFooter;